export enum NursingTaskType {
  // Source: Task Overview Form
  SHOWER = 'SHOWER',
  // Source: Task Overview Form
  BATH = 'BATH',
  // Source: Task Overview Form
  HAIRWASH = 'HAIRWASH',
  // Source: Task Overview Form
  STOOL = 'STOOL',
  // Source: Task Overview Form
  CLEANBEDSHEET = 'CLEANBEDSHEET',
  // Source: Task Overview Form
  MANICURE = 'MANICURE',
  // Source: Task Overview Form
  FOOTCARE = 'FOOTCARE',
  // Source: Task Overview Form
  HAIRDRESSER = 'HAIRDRESSER',
  // Source: Medication Sheet Form
  MEDICATION = 'MEDICATION',
  // Source: Medication Sheet Form
  PEG = 'PEG',
  // Source: Wound Therapy Form
  WOUNDTHERAPY = 'WOUNDTHERAPY',
  // Source: Care Planning Form Page 2 (catheterMeasure.intervalWeeks), weeks --> days translation neccessary
  CATHETERCHANGE = 'CATHETERCHANGE',
  // Source: Care Planning Form Page 2 (catheterMeasure.changeBagDay)
  CATHETERBAG_CHANGE_DAY = 'CATHETERBAG_CHANGE_DAY',
  // Source: Care Planning Form Page 2 (catheterMeasure.changeBagNight)
  CATHETERBAG_CHANGE_NIGHT = 'CATHETERBAG_CHANGE_NIGHT',
  // Source: Care Planning Form Page 2 (stomaMeasure.changeBag)
  STOMABAGCHANGE = 'STOMABAGCHANGE',
  // Source: Care Planning Form Page 2 (stomaMeasure.changePlate)
  STOMAPLATECHANGE = 'STOMAPLATECHANGE',
  // Source: Care Planning Form Page 3 (weightControlInterval) , weeks --> days translation neccessary
  WEIGHTCONTROL = 'WEIGHTCONTROL',
  // Source: Task Overview Form, will be a daily task
  NUTRITIONPROTOCOL = 'NUTRITIONPROTOCOL',
  // Source: Vitals Signs Form / Task Overview Form
  VITALSIGNMEASUREMENT = 'VITALSIGNMEASUREMENT',
  // Source: Task Overview Form
  SETMEDICINES = 'SETMEDICINES',
  // Source: Task Overview Form
  CONTROLMEDICINES = 'CONTROLMEDICINES',
  // Source: Task Overview Form
  DKRINSE = 'DKRINSE',
  // Source: Task Overview Form
  DOCTORAPPOINTMENT = 'DOCTORAPPOINTMENT',
  // Source: Task Overview Form
  DOCTORVISIT = 'DOCTORVISIT',
  FOOTBATH = 'FOOTBATH',
  BARBER = 'BARBER',
  OTHER = 'OTHER',
}
